export const VALIDATION_RULES = {
    email: {
        maxCharacters: 70,
    },
};
